import { FunctionComponent, ReactNode } from 'react';

import { StackAlignItems, VStack } from '../Stack';
import { Stub } from '../Stub';
import { cn } from '../../lib/css/className/className';
import { ParagraphStub } from '../Paragraph';
import { TestProps } from '../../internal/types/testTypes';

import './MediaItemStub.css';

const cls = cn('MediaItemStub');

/**
 * Пропсы компонента MediaItemStub
 */
export interface MediaItemStubProps extends TestProps {
    /**
     * Названия классов для элемента.
     */
    className?: string;
    /**
     * Ширина элемента
     */
    width: string | number;
    /**
     * Высота элемента
     */
    height: string | number;
    /**
     * Основной текст (заголовок или абзац)
     */
    title?: ReactNode;

    /**
     * Дополнительный поясняющий текст, показывается только при наличии title
     */
    caption?: string;

    /**
     * Выравнивание содержимого по горизонтали
     */
    alignItems?: StackAlignItems;
}

/**
 * Стаб для компонента MediaItem
 * @param props - пропсы компонента MediaItemStub
 * @returns стаб компонента MediaItem
 */
export const MediaItemStub: FunctionComponent<MediaItemStubProps> = function MediaItem(props) {
    const {
        'data-testid': dataTestId = 'MediaItemStub',
        className,
        alignItems = 'flex-start',
        title,
        width,
        height,
        caption,
    } = props;

    return (
        <VStack data-testid={dataTestId} gap={'4'} alignItems={alignItems} inline className={cls({}, [className])}>
            <Stub className={cls('stub')} width={width} height={height} />
            {title && (
                <VStack className={cls('title-stub')}>
                    <ParagraphStub size="m" width="100%" />
                    {caption && <ParagraphStub size="m" width="60%" />}
                </VStack>
            )}
        </VStack>
    );
};
